import { instance } from './index';

// 매체나 지면에 정의되는 옵션 그룹
//option gruop list
function optionsList() {
  return instance.get('api/options');
}

// option group detail
function detailOptions(id) {
  return instance.get(`api/options/${id}`);
}

// option group create
function createOptionGroup(data) {
  return instance.post('api/options', data);
}

// option group update
function updateOptionGroup(id, data) {
  return instance.put(`api/options/${id}`, data);
}

// 해당 옵션 그룹의 아이템 목록 조회
function optionsItemList(id) {
  return instance.get(`api/options/${id}/items`);
}

// 해당 옵션 그룹의 아이템 추가
function createOptionsItemList(id, data) {
  return instance.post(`api/options/${id}/items`, data);
}

// 해당 옵션 그룹의 아이템 수정
function updateOptionsItemList(id, item_id, data) {
  return instance.put(`api/options/${id}/items/${item_id}`, data);
}

// 해당 옵션 그룹의 아이템 수정
function deleteOptionItem(optionGroupId, optionItemId) {
  return instance.delete(`api/options/${optionGroupId}/items/${optionItemId}`);
}

export {
  optionsList,
  detailOptions,
  createOptionGroup,
  updateOptionGroup,
  optionsItemList,
  createOptionsItemList,
  updateOptionsItemList,
  deleteOptionItem,
};
